import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap, tap } from 'rxjs/operators';
import { CommonActionKey, DateHelper, EnumHelper, LiquidityEvent, ResolutionStatus, SimpleDialogService } from 'common';
import { LitigationService } from '../../litigation/litigation.service';
import { AccountLiquidityEventAddComponent } from '../account-liquidity-event-add/account-liquidity-event-add.component';

@UntilDestroy()
@Component({
    selector: 'ifb-account-liquidity-event-widget',
    templateUrl: './account-liquidity-event-widget.component.html',
    styleUrls: ['./account-liquidity-event-widget.component.scss'],
    standalone: false
})
export class AccountLiquidityEventWidgetComponent implements OnInit {
  @Input() loanId: number;
  @Input() data: LiquidityEvent;

  @Output()
  updated = new EventEmitter<void>();

  resolutionStatusName: string;

  constructor(
    private readonly dialog: MatDialog,
    private readonly litigationService: LitigationService,
    private readonly simpleDialogService: SimpleDialogService
  ) { }

  ngOnInit(): void {
    this.litigationService.getLiquidityEventForLoan(this.loanId)
      .pipe(untilDestroyed(this))
      .subscribe((data: LiquidityEvent) => this.refreshData(data));
  }

  private refreshData(data: LiquidityEvent): void {
    this.data = data;
    this.resolutionStatusName = this.data.resolutionStatus ? EnumHelper.getNameFromValue(ResolutionStatus, this.data.resolutionStatus) : null;
  }

  addLiquidityEventDialog(): void {
    AccountLiquidityEventAddComponent.show(this.dialog, this.data)
      .pipe(
        switchMap(data => {
          if (data) {
            return this.litigationService.saveLiquidityEvent(this.data.litigationId, this.loanId, data.resolutionStatus, DateHelper.getLocalDateAsUTC(data.resolutionDate))
          }
        }),
        tap(() => this.updated.emit()),
        switchMap(() => this.litigationService.getLiquidityEventForLoan(this.loanId)))
      .subscribe(res => this.refreshData(res));
  }

  delete(): void {
    this.simpleDialogService.openSimpleConfirmDialog(`Are you sure you want to remove ${this.resolutionStatusName} resolution?`, 'Confirm')
      .subscribe((result: CommonActionKey) => {
        if (result === CommonActionKey.Confirm) {
          this.litigationService.deleteLiquidityEvent(this.data.litigationId, this.loanId)
            .pipe(
              untilDestroyed(this),
              switchMap(() => this.litigationService.getLiquidityEventForLoan(this.loanId)))
            .subscribe(res => this.data = res);
        }
      });
  }
}
